import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MATERIALS } from "../lib/site";

export const Materials = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="materials" data-testid="materials-catalog" className="relative py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="mb-16">
          <span className="overline text-[#B87333]">/ Trading Catalogue</span>
          <h2 className="font-serif text-[clamp(2rem,5vw,4.5rem)] leading-[1.02] tracking-[-0.02em] mt-6 max-w-3xl">
            Materials, sourced to <span className="italic text-[#B87333]">spec.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          {/* Spotlight image */}
          <div className="relative lg:sticky lg:top-28 aspect-[4/5] w-full overflow-hidden rounded-sm border border-white/10">
            <AnimatePresence mode="wait">
              <motion.img
                key={active}
                src={MATERIALS[active].img}
                alt={MATERIALS[active].name}
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 w-full h-full object-cover"
              />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-t from-[#070707]/70 to-transparent pointer-events-none" />
            <div className="absolute bottom-6 left-6 z-10">
              <div className="font-grotesk text-xs tracking-[0.2em] text-[#B87333]">{MATERIALS[active].idx}</div>
              <div className="font-serif text-2xl text-[#F5F5F0]">{MATERIALS[active].name}</div>
            </div>
          </div>

          {/* List */}
          <div className="border-t border-white/10">
            {MATERIALS.map((m, i) => (
              <button
                key={m.idx}
                data-testid={`material-item-${i}`}
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`group w-full text-left border-b border-white/10 py-8 px-2 md:px-4 flex items-center justify-between gap-6 transition-colors duration-300 ${
                  active === i ? "bg-white/[0.03]" : ""
                }`}
              >
                <div className="flex items-baseline gap-6">
                  <span className={`font-grotesk text-xs tracking-[0.2em] transition-colors ${active === i ? "text-[#B87333]" : "text-[#8A8A82]"}`}>
                    {m.idx}
                  </span>
                  <div>
                    <div className={`font-serif text-2xl md:text-4xl transition-colors ${active === i ? "text-[#F5F5F0]" : "text-[#8A8A82]"}`}>
                      {m.name}
                    </div>
                    <div className="font-body text-sm text-[#8A8A82] mt-2">{m.spec}</div>
                  </div>
                </div>
                <span className={`text-2xl transition-all duration-300 ${active === i ? "text-[#B87333] translate-x-0 opacity-100" : "text-[#8A8A82] -translate-x-2 opacity-0 group-hover:opacity-100 group-hover:translate-x-0"}`}>↗</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
